(function () {
  'use strict';

  var COOKIE_NAME = 'occhio_attrib';
  var FORM_SELECTOR = 'form.js-occhio-contact';

  var FLAG = function (iso) {
    return 'https://flagcdn.com/w40/' + iso + '.png';
  };

  var DIALS = [
    { iso: 'us', code: '1', name: 'United States', aliases: 'usa america' },
    { iso: 'ca', code: '1', name: 'Canada', aliases: '' },
    { iso: 'eg', code: '20', name: 'Egypt', aliases: '' },
    { iso: 'za', code: '27', name: 'South Africa', aliases: '' },
    { iso: 'nl', code: '31', name: 'Netherlands', aliases: 'holland' },
    { iso: 'be', code: '32', name: 'Belgium', aliases: '' },
    { iso: 'fr', code: '33', name: 'France', aliases: '' },
    { iso: 'es', code: '34', name: 'Spain', aliases: '' },
    { iso: 'it', code: '39', name: 'Italy', aliases: '' },
    { iso: 'ch', code: '41', name: 'Switzerland', aliases: '' },
    { iso: 'at', code: '43', name: 'Austria', aliases: '' },
    { iso: 'gb', code: '44', name: 'United Kingdom', aliases: 'uk britain england' },
    { iso: 'dk', code: '45', name: 'Denmark', aliases: '' },
    { iso: 'se', code: '46', name: 'Sweden', aliases: '' },
    { iso: 'no', code: '47', name: 'Norway', aliases: '' },
    { iso: 'pl', code: '48', name: 'Poland', aliases: '' },
    { iso: 'de', code: '49', name: 'Germany', aliases: 'deutschland' },
    { iso: 'mx', code: '52', name: 'Mexico', aliases: '' },
    { iso: 'ar', code: '54', name: 'Argentina', aliases: '' },
    { iso: 'br', code: '55', name: 'Brazil', aliases: 'brasil' },
    { iso: 'cl', code: '56', name: 'Chile', aliases: '' },
    { iso: 'my', code: '60', name: 'Malaysia', aliases: '' },
    { iso: 'au', code: '61', name: 'Australia', aliases: '' },
    { iso: 'id', code: '62', name: 'Indonesia', aliases: '' },
    { iso: 'ph', code: '63', name: 'Philippines', aliases: '' },
    { iso: 'nz', code: '64', name: 'New Zealand', aliases: '' },
    { iso: 'sg', code: '65', name: 'Singapore', aliases: '' },
    { iso: 'th', code: '66', name: 'Thailand', aliases: '' },
    { iso: 'jp', code: '81', name: 'Japan', aliases: '' },
    { iso: 'kr', code: '82', name: 'South Korea', aliases: 'korea' },
    { iso: 'vn', code: '84', name: 'Vietnam', aliases: '' },
    { iso: 'cn', code: '86', name: 'China', aliases: '' },
    { iso: 'tr', code: '90', name: 'Turkey', aliases: '' },
    { iso: 'in', code: '91', name: 'India', aliases: '' },
    { iso: 'pk', code: '92', name: 'Pakistan', aliases: '' },
    { iso: 'lk', code: '94', name: 'Sri Lanka', aliases: '' },
    { iso: 'ir', code: '98', name: 'Iran', aliases: '' },
    { iso: 'ma', code: '212', name: 'Morocco', aliases: '' },
    { iso: 'ng', code: '234', name: 'Nigeria', aliases: '' },
    { iso: 'ke', code: '254', name: 'Kenya', aliases: '' },
    { iso: 'pt', code: '351', name: 'Portugal', aliases: '' },
    { iso: 'ie', code: '353', name: 'Ireland', aliases: '' },
    { iso: 'fi', code: '358', name: 'Finland', aliases: '' },
    { iso: 'cz', code: '420', name: 'Czechia', aliases: 'czech' },
    { iso: 'hk', code: '852', name: 'Hong Kong', aliases: '' },
    { iso: 'tw', code: '886', name: 'Taiwan', aliases: '' },
    { iso: 'lb', code: '961', name: 'Lebanon', aliases: '' },
    { iso: 'jo', code: '962', name: 'Jordan', aliases: '' },
    { iso: 'kw', code: '965', name: 'Kuwait', aliases: '' },
    { iso: 'sa', code: '966', name: 'Saudi Arabia', aliases: 'ksa' },
    { iso: 'om', code: '968', name: 'Oman', aliases: '' },
    { iso: 'ae', code: '971', name: 'United Arab Emirates', aliases: 'uae dubai' },
    { iso: 'il', code: '972', name: 'Israel', aliases: '' },
    { iso: 'bh', code: '973', name: 'Bahrain', aliases: '' },
    { iso: 'qa', code: '974', name: 'Qatar', aliases: '' }
  ].sort(function (a, b) {
    var diff = parseInt(a.code, 10) - parseInt(b.code, 10);
    if (diff !== 0) return diff;
    return a.name.localeCompare(b.name);
  });

  var CODES_BY_LENGTH = DIALS.slice()
    .map(function (row) {
      return row.code;
    })
    .filter(function (code, index, list) {
      return list.indexOf(code) === index;
    })
    .sort(function (a, b) {
      return b.length - a.length;
    });

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
      var rand = (Math.random() * 16) | 0;
      var value = char === 'x' ? rand : (rand & 0x3) | 0x8;
      return value.toString(16);
    });
  }

  function readNamedCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    if (!match) return '';
    try {
      return decodeURIComponent(match[1]);
    } catch (err) {
      return match[1];
    }
  }

  function cookieFirstSegment(name) {
    var raw = readNamedCookie(name);
    if (!raw) return '';
    return raw.split(/[|^;]/)[0] || raw;
  }

  function gaClientId() {
    var parts = readNamedCookie('_ga').split('.');
    if (parts.length >= 4) return parts[parts.length - 2] + '.' + parts[parts.length - 1];
    return '';
  }

  function attribCookie() {
    try {
      var raw = readNamedCookie(COOKIE_NAME);
      if (!raw) return {};
      return JSON.parse(raw) || {};
    } catch (err) {
      return {};
    }
  }

  function writeAttribCookie(data) {
    try {
      document.cookie =
        COOKIE_NAME +
        '=' +
        encodeURIComponent(JSON.stringify(data)) +
        '; Max-Age=' +
        90 * 24 * 60 * 60 +
        '; Path=/; SameSite=Lax' +
        (window.location.protocol === 'https:' ? '; Secure' : '');
    } catch (err) {}
  }

  function mergeParams() {
    var out = {};
    var sources = [];
    var cookie = attribCookie();
    var attrib = window.OcchioAttrib || {};
    sources.push(cookie.params);
    sources.push(attrib.params);
    try {
      var sp = new URLSearchParams(window.location.search);
      var fromUrl = {};
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid', 'msclkid', 'ttclid', 'gbraid', 'wbraid'].forEach(function (k) {
        var v = sp.get(k);
        if (v) fromUrl[k] = v;
      });
      sources.push(fromUrl);
    } catch (err) {}
    sources.forEach(function (src) {
      if (!src || typeof src !== 'object') return;
      Object.keys(src).forEach(function (k) {
        if (src[k] && !out[k]) out[k] = src[k];
      });
    });
    return out;
  }

  function stampAttribFields(form) {
    var data = attribCookie();
    var attrib = window.OcchioAttrib || {};
    var params = mergeParams();
    var vid = attrib.vid || data.vid || '';
    try {
      var urlVid = new URLSearchParams(window.location.search).get('vid');
      if (!vid && urlVid) vid = urlVid;
    } catch (err) {}
    var landing = attrib.entryUrl || data.entryUrl || window.location.href;
    var entryPath =
      attrib.entryPath || data.entryPath || window.location.pathname + window.location.search;
    var referrer = attrib.initialReferrer || data.initialReferrer || document.referrer || '';

    if (!vid) vid = uuid();

    data.vid = vid;
    data.created = data.created || new Date().toISOString();
    data.params = params;
    data.entryUrl = landing;
    data.entryPath = entryPath;
    if (referrer) data.initialReferrer = referrer;
    else if (!data.initialReferrer) data.initialReferrer = '';
    writeAttribCookie(data);

    var map = {
      visitor_id: vid,
      utm_source: params.utm_source || '',
      utm_medium: params.utm_medium || '',
      utm_campaign: params.utm_campaign || '',
      utm_content: params.utm_content || '',
      utm_term: params.utm_term || '',
      gclid: params.gclid || '',
      fbclid: params.fbclid || '',
      landing_page: landing,
      initial_referrer: referrer,
      current_page: window.location.href,
      ga_client_id: gaClientId(),
      clarity_user: cookieFirstSegment('_clck'),
      clarity_session: cookieFirstSegment('_clsk')
    };

    Object.keys(map).forEach(function (key) {
      var input = form.querySelector('[data-attrib-field="' + key + '"]');
      if (!input) return;
      if (
        map[key] ||
        key === 'visitor_id' ||
        key === 'landing_page' ||
        key === 'current_page' ||
        key === 'initial_referrer'
      ) {
        input.value = map[key] || '';
      }
    });
  }

  function digits(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function nationalDigits(value) {
    return digits(value).replace(/^0+/, '');
  }

  function findDial(iso, code) {
    var i;
    for (i = 0; i < DIALS.length; i += 1) {
      if (iso && DIALS[i].iso === iso) return DIALS[i];
    }
    for (i = 0; i < DIALS.length; i += 1) {
      if (DIALS[i].code === code) return DIALS[i];
    }
    return DIALS.filter(function (row) {
      return row.code === '971';
    })[0];
  }

  function haystack(row) {
    return ('+' + row.code + ' ' + row.code + ' ' + row.name + ' ' + (row.aliases || '') + ' ' + row.iso).toLowerCase();
  }

  function matches(row, query) {
    if (!query) return true;
    var q = query.trim().toLowerCase();
    if (!q) return true;
    var num = digits(q);
    if (num && ('+' + row.code).indexOf('+' + num) === 0) return true;
    if (num && row.code.indexOf(num) === 0) return true;
    return haystack(row).indexOf(q) !== -1;
  }

  function bindDial(root, hidden, onChange) {
    var button = root.querySelector('.gcf-dial__btn');
    var flag = root.querySelector('.gcf-dial__flag');
    var codeEl = root.querySelector('.gcf-dial__code');
    var panel = root.querySelector('.gcf-dial__panel');
    var search = root.querySelector('.gcf-dial__search');
    var list = root.querySelector('.gcf-dial__list');
    var selected = findDial('ae', hidden.value || '971');
    var activeIndex = 0;
    var visible = [];

    function setSelected(row, close) {
      selected = row;
      hidden.value = row.code;
      hidden.setAttribute('data-iso', row.iso);
      flag.src = FLAG(row.iso);
      flag.alt = '';
      codeEl.textContent = '+' + row.code;
      button.setAttribute('aria-label', 'Country code +' + row.code + ' ' + row.name);
      if (onChange) onChange(row);
      if (close) closePanel();
    }

    function renderList(query) {
      visible = DIALS.filter(function (row) {
        return matches(row, query);
      });
      list.innerHTML = '';
      if (!visible.length) {
        var empty = document.createElement('li');
        empty.className = 'gcf-dial__empty';
        empty.textContent = 'No match';
        list.appendChild(empty);
        activeIndex = 0;
        return;
      }
      visible.forEach(function (row, index) {
        var item = document.createElement('li');
        item.className = 'gcf-dial__option';
        item.setAttribute('role', 'option');
        item.setAttribute('data-iso', row.iso);
        item.setAttribute('data-code', row.code);
        if (row.iso === selected.iso && row.code === selected.code) {
          item.setAttribute('aria-selected', 'true');
          activeIndex = index;
        }
        item.innerHTML =
          '<img class="gcf-dial__option-flag" src="' +
          FLAG(row.iso) +
          '" alt="" width="20" height="15" loading="lazy">' +
          '<span class="gcf-dial__option-code">+' +
          row.code +
          '</span>' +
          '<span class="gcf-dial__option-name">' +
          row.name +
          '</span>';
        item.addEventListener('mousedown', function (event) {
          event.preventDefault();
          setSelected(row, true);
        });
        list.appendChild(item);
      });
      paintActive();
    }

    function paintActive() {
      var items = list.querySelectorAll('.gcf-dial__option');
      items.forEach(function (item, index) {
        item.classList.toggle('is-active', index === activeIndex);
      });
      if (items[activeIndex]) {
        items[activeIndex].scrollIntoView({ block: 'nearest' });
      }
    }

    function openPanel() {
      panel.hidden = false;
      root.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      search.value = '';
      renderList('');
      window.setTimeout(function () {
        search.focus();
      }, 0);
    }

    function closePanel() {
      panel.hidden = true;
      root.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
    }

    function togglePanel() {
      if (panel.hidden) openPanel();
      else closePanel();
    }

    button.addEventListener('click', function (event) {
      event.preventDefault();
      togglePanel();
    });

    button.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openPanel();
      }
    });

    search.addEventListener('input', function () {
      activeIndex = 0;
      renderList(search.value);
    });

    search.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (visible.length) activeIndex = Math.min(activeIndex + 1, visible.length - 1);
        paintActive();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (visible.length) activeIndex = Math.max(activeIndex - 1, 0);
        paintActive();
      } else if (event.key === 'Enter') {
        event.preventDefault();
        if (visible[activeIndex]) setSelected(visible[activeIndex], true);
      } else if (event.key === 'Escape') {
        event.preventDefault();
        closePanel();
        button.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closePanel();
    });

    setSelected(selected, false);
    closePanel();

    return {
      getSelected: function () {
        return selected;
      },
      setByCode: function (code, iso) {
        setSelected(findDial(iso, code), false);
      }
    };
  }

  function detectPrefix(raw) {
    var text = String(raw || '').trim();
    if (!text) return null;
    if (text.charAt(0) !== '+' && text.indexOf('00') !== 0) return null;
    var num = digits(text);
    var i;
    for (i = 0; i < CODES_BY_LENGTH.length; i += 1) {
      if (num.indexOf(CODES_BY_LENGTH[i]) === 0) {
        return {
          code: CODES_BY_LENGTH[i],
          rest: num.slice(CODES_BY_LENGTH[i].length)
        };
      }
    }
    return null;
  }

  function bindForm(form) {
    if (!form || form.getAttribute('data-gcf-bound') === 'true') return;
    form.setAttribute('data-gcf-bound', 'true');

    var first = form.querySelector('#gcf-first');
    var last = form.querySelector('#gcf-last');
    var name = form.querySelector('#gcf-name');
    var hiddenDial = form.querySelector('#gcf-dial');
    var national = form.querySelector('#gcf-national');
    var phone = form.querySelector('#gcf-phone');
    var phoneCountry = form.querySelector('#gcf-phone-country');
    var submission = form.querySelector('#gcf-submission');
    var honey = form.querySelector('#gcf-website');
    var dialRoot = form.querySelector('[data-gcf-dial]');
    var dial = bindDial(dialRoot, hiddenDial);

    stampAttribFields(form);

    if (national) {
      national.addEventListener('input', function () {
        var hit = detectPrefix(national.value);
        if (!hit) return;
        dial.setByCode(hit.code);
        national.value = hit.rest;
      });
    }

    form.addEventListener('submit', function (event) {
      if (honey && honey.value) {
        event.preventDefault();
        return;
      }

      if (submission) submission.value = uuid();
      stampAttribFields(form);

      var firstName = first ? first.value.trim() : '';
      var lastName = last ? last.value.trim() : '';
      if (name) name.value = [firstName, lastName].filter(Boolean).join(' ');

      var row = dial.getSelected();
      var code = row && row.code ? row.code : '971';
      var local = nationalDigits(national && national.value);
      if (phoneCountry) phoneCountry.value = '+' + code;
      if (phone) phone.value = local ? '+' + code + local : '';
    });
  }

  function init() {
    document.querySelectorAll(FORM_SELECTOR).forEach(bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.setTimeout(function () {
    document.querySelectorAll(FORM_SELECTOR).forEach(function (form) {
      stampAttribFields(form);
    });
  }, 500);
  window.setTimeout(function () {
    document.querySelectorAll(FORM_SELECTOR).forEach(function (form) {
      stampAttribFields(form);
    });
  }, 2600);
})();
